import { StandaloneProject } from '../../entities/standalone-project';

// MF-39 — the coding agent moves a linked task's status automatically only when the project has
// opted in; nothing sets this by default (no seeding/migration), so this warns before a run starts
// on a project that hasn't. Advisory only — never blocks starting the task.
export interface AgentRoleWarning {
  missingWorking: boolean;
  missingReview: boolean;
}

export const getAgentRoleWarning = (project: StandaloneProject): AgentRoleWarning | null => {
  const missingWorking = !project.statuses.some((s) => s.agentRole === 'working');
  const missingReview = !project.statuses.some((s) => s.agentRole === 'review');
  return missingWorking || missingReview ? { missingWorking, missingReview } : null;
};
